import {appAPI} from '../../../api';
import {INewTariff, ITariff} from '../../../models/ITariff';

type UpdateTariffPayload = Partial<{
    name: string;
    description: string;
    price_per_tracker_per_day: string;
    price_per_frozen_tracker_per_day: string;
    is_default: boolean;
    is_active: boolean;
}>;
const basePath = '/tariff';

/**
 * Пустая цена заморозки означает «оставить дефолт тарифа» (в колонке стоит
 * DEFAULT 10). Отправлять её пустой строкой нельзя: на бэке поле опциональное,
 * но при наличии проверяется как целое (@Matches(/^\d+$/)), и '' даст 400.
 */
const omitEmptyFrozenPrice = <T extends { price_per_frozen_tracker_per_day?: string }>(
    payload: T,
): T => {
    if (payload.price_per_frozen_tracker_per_day?.trim()) return payload;
    const {price_per_frozen_tracker_per_day: _omitted, ...rest} = payload;
    return rest as T;
};

export const tariffsAPI = {
    add: async (tariff: INewTariff): Promise<ITariff> => {
        const res = await appAPI.post(basePath, omitEmptyFrozenPrice({...tariff}));
        return res.data;
    },
    getAll: async (): Promise<ITariff[]> => {
        const res = await appAPI.get(basePath);
        return res.data;
    },
    getById: async (id: string): Promise<ITariff> => {
        const res = await appAPI.get(`${basePath}/${id}`);
        return res.data;
    },
    update: async (tariff: ITariff): Promise<ITariff> => {
        const dto: UpdateTariffPayload = {
            name: tariff.name,
            description: tariff.description ?? undefined,
            price_per_tracker_per_day: tariff.price_per_tracker_per_day,
            price_per_frozen_tracker_per_day: tariff.price_per_frozen_tracker_per_day,
            is_default: tariff.is_default,
            is_active: tariff.is_active,
        };
        const res = await appAPI.patch(`${basePath}/${tariff.id}`, omitEmptyFrozenPrice(dto));
        return res.data;
    },
    delete: async (tariffId: string): Promise<ITariff> => {
        const res = await appAPI.delete(`${basePath}/${tariffId}`);
        return res.data;
    },
};